import { Box, Spinner } from '@radix-ui/themes'
import React from 'react'
import { useAsync } from 'react-use'
import { useCurrentOrg } from '~/features/orgnisations/hooks/useCurrentOrg'
import { useSupabaseClient } from '~/hooks/useSupabaseClient'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

interface SecuredImageProps {
  fileName: string
  zoomable?: boolean
  imgProps?: React.ImgHTMLAttributes<HTMLImageElement>
}

const SecuredOrgImage = ({ fileName, zoomable, imgProps }: SecuredImageProps) => {
  const org = useCurrentOrg()
  const supabaseClient = useSupabaseClient()
  const [imgUrl, setImgUrl] = React.useState<string | null>(null)

  useAsync(async () => {
    if (!org?.id) {
      return
    }

    const path = fileName.startsWith(`${org.id}/`) ? fileName : `${org.id}/${fileName}`
    const { data, error } = await supabaseClient.storage.from('org_content').createSignedUrl(path, 6000) // 60 seconds

    if (error) {
      console.error('Error creating signed URL:', error)
      return
    }

    setImgUrl(data.signedUrl)
  }, [])

  if (!imgUrl) {
    return (
      <Box
        width={imgProps?.width ? `${imgProps.width}px` : undefined}
        height={imgProps?.height ? `${imgProps.height}px` : undefined}
      >
        <Spinner className="m-auto" />
      </Box>
    )
  }

  if (zoomable) {
    return (
      <Zoom>
        <img src={imgUrl} {...imgProps} />
      </Zoom>
    )
  }

  return <img src={imgUrl} {...imgProps} />
}

export default SecuredOrgImage
